export default "__VITE_ASSET__BCrtBtI8__"